/*
 * Proprietary and confidential | 2026 | SoundTalks NV
 */

const prefix = (type) => `st/admin/alertRules/${type}`;

export const LIST_LOAD_START = prefix('LIST_LOAD_START');
export const LIST_LOAD_SUCCESS = prefix('LIST_LOAD_SUCCESS');
export const LIST_LOAD_FAILED = prefix('LIST_LOAD_FAILED');

export const LOAD_START = prefix('LOAD_START');
export const LOAD_SUCCESS = prefix('LOAD_SUCCESS');
export const LOAD_FAILED = prefix('LOAD_FAILED');

export const CREATE_START = prefix('CREATE_START');
export const CREATE_SUCCESS = prefix('CREATE_SUCCESS');
export const CREATE_FAILED = prefix('CREATE_FAILED');

export const UPDATE_START = prefix('UPDATE_START');
export const UPDATE_SUCCESS = prefix('UPDATE_SUCCESS');
export const UPDATE_FAILED = prefix('UPDATE_FAILED');

export const VERSIONS_LIST_LOAD_START = prefix('VERSIONS_LIST_LOAD_START');
export const VERSIONS_LIST_LOAD_SUCCESS = prefix('VERSIONS_LIST_LOAD_SUCCESS');
export const VERSIONS_LIST_LOAD_FAILED = prefix('VERSIONS_LIST_LOAD_FAILED');

export const VERSION_CREATE_START = prefix('VERSION_CREATE_START');
export const VERSION_CREATE_SUCCESS = prefix('VERSION_CREATE_SUCCESS');
export const VERSION_CREATE_FAILED = prefix('VERSION_CREATE_FAILED');

export const CLEAR = prefix('CLEAR');
export const CLEAR_SINGLE = prefix('CLEAR_SINGLE');
export const CLEAR_VERSIONS = prefix('CLEAR_VERSIONS');
